export const TAG_COLOR_TABLE = {
  AllTimeLowest: 'red', // 역대최저
  MonthLowest: 'pink', // 이번달최저
  EyeFocus: 'blue', // 시선집중
  Toksopic: 'orange', // 똑소픽
  NowLowest: 'blue', // 지금할인

  //  -- 보여지지 않는 태그 --
  TodayLowest: 'orange', // 오늘최저
  TomorrowLowest: 'orange', // 내일최저
  ManwonHappinessFood: 'orange', // 만원행복식품
  ManwonHappinessLife: 'orange', // 만원행복생활

  // -- 추가 태그 정의 필요 --
  HotDeal: 'orange',
  WeekBest: 'orange',
  MonthBest: 'orange',
  New: 'black',
} as const

export const TAG_TOOLTIP_TABLE = {
  AllTimeLowest: null,
  NowLowest: null,
  EyeFocus: (
    <p className="flex items-center gap-1">
      <span>최근 3일</span>
      <span className="text-point-blue">조회수 상위 1%</span>
    </p>
  ),
  Toksopic: (
    <p className="flex items-center gap-1">
      <span>똑소</span>
      <span className="text-point-orange">추천상품</span>
    </p>
  ),
  MonthLowest: null,

  //  -- 보여지지 않는 태그 --
  TodayLowest: null,
  TomorrowLowest: null,
  ManwonHappinessFood: null,
  ManwonHappinessLife: null,

  // -- 추가 태그 정의 필요 --
  HotDeal: null,
  WeekBest: null,
  MonthBest: null,
  New: null,
} as const
